<template>
  <div class="fixed-center text-center">
    <p>
      <img
        src="../assets/sad.svg"
        style="width:30vw;max-width:150px;"
      >
    </p>
    <p class="text-faded">
      Sorry, you have no permission to be here...<strong>(401)</strong>
    </p>
    <q-btn
      color="secondary"
      style="width:200px;"
      @click="$router.push('/')"
    >
      Go back
    </q-btn>
  </div>
</template>

<script>
export default {
  name: 'Error404'
}
</script>
